module.exports = __webpack_public_path__ + "img/my-gold-text.a3d2d73f.png";